import { Card, Form, Typography } from "antd";
import React from "react";
import { useBookingSelector } from "../../../hooks/useBookingSelector";
import { TorRulesFormFields } from "./TorRulesFormFields";
import { useHydrateTorRules } from "./useHydrateTorRules";
import type { AddNewTorProps } from "./types";

const { Text } = Typography;

export const AddNewTor = (props: AddNewTorProps) => {
  const {
    title = "TOR Rules — New Term",
    disabled = false,
    footerNote,
    maxRules,
    embedded = false,
    onRegisterCopy,
  } = props;

  const bookingDetails = useBookingSelector();

  useHydrateTorRules({
    source: {
      torRules: bookingDetails?.torRules,
      torRuleCondition: bookingDetails?.torRuleCondition,
    },
  });

  const content = (
    <>
      <Form layout="vertical" name="new-tor-rules" scrollToFirstError className="bf-main">
        <TorRulesFormFields disabled={disabled} maxRules={maxRules} onRegisterCopy={onRegisterCopy} />
      </Form>
      {footerNote ? (
        <Text type="secondary" style={{ display: "block", marginTop: 16, fontSize: 13 }}>
          {footerNote}
        </Text>
      ) : null}
    </>
  );

  if (embedded) return content;

  return (
    <Card title={title} bodyStyle={{ paddingTop: 16 }}>
      {content}
    </Card>
  );
};
